import type UppyType from "@uppy/core";
import { getUploadURL, type UploadSource, type ContentDisposition } from "../shared";
import { type UppyFile } from "@uppy/core";

interface GetUppy {
  getBucket?: (file: File | UppyFile) => string;
  uploadSource?: UploadSource;
  contentDisposition?: ContentDisposition;
}
export const getUppy = async ({ getBucket, uploadSource, contentDisposition }: GetUppy): Promise<UppyType> => {
  const [{ default: S3 }, { default: Uppy }] = await Promise.all([import("@uppy/aws-s3"), import("@uppy/core")]);

  const uppy = new Uppy({
    id: "@file-upload/AwsS3",
  });

  uppy.use(S3, {
    async getUploadParameters(file) {
      const config = await getUploadURL(file, { getBucket, uploadSource, contentDisposition });
      // urlSmall / cdnUrl are not part of the signed S3 POST policy, so they cannot be sent as form
      // fields (S3 rejects unsigned extras). Stash them in the file's meta instead — the post-upload
      // descriptor step reads them from there. `fields` (incl. `key`) is merged into meta by the
      // plugin, so `file.meta.key` is still populated.
      uppy.setFileMeta(file.id, { urlSmall: config.urlSmall, cdnUrl: config.cdnUrl });
      return {
        method: "POST",
        url: config.url,
        fields: config.fields,
      };
    },
  });

  return uppy;
};
